(function(ws) {
    'use strict';

    ws.views.recentRFQs = ws.views.recentItems.extend({
        GTM_EVENT_ACTION: 'click_unprocessed_quote_requests',
        GTM_EVENT_LABEL: 'quote_request_ID',

        ADOBE_EVENT_ACTION: 'view my pending quote requests',

        events: _.extend({}, ws.views.recentItems.prototype.events, {
            'click table ~ a': 'trackCreateLink'
        }),

        trackCreateLink: function (e) {
            e.preventDefault();

            // Send tracking data to adobe Analytics
            dataLayerAA.event = {};
            dataLayerAA.event.action = 'request a new quote';
            _satellite.track('event:dashboard');

            // Navigate away after the tracking is complete
            window.location.href = $(e.currentTarget).attr('href');
        }
    });
})(westcon);
